/* Answers page behaviour. Loaded only on Answers pages, deferred.
   Fork of the prototype's answers.js: the client-index search layer, the
   runtime cloning of the mobile bar, and the handcuffs easter egg are not
   ported. Search is a server-rendered GET, and typing swaps in the results
   region of that same page (bindSearchForms). The mobile bar is rendered by
   Blade. The canvas reads .kb-main__inner through mainInner(). */
(function() {
  const shell = document.querySelector('.kb-shell');
  const phone = window.matchMedia('(max-width: 1020px)');
  const home = document.getElementById('answers-home');

  function mainInner() {
    return document.querySelector('.kb-main__inner');
  }

  /* Logo sticks with the Categories header and leaves with it at the footer. */
  function syncLogo() {
    const pinned = document.querySelector('.kb-side__pinned');
    const sideSticky = document.querySelector('.kb-side__sticky');
    const inner = document.querySelector('#nav .nav__inner');
    if (!pinned || !sideSticky || !inner) {
      return;
    }
    if (phone.matches) {
      inner.style.transform = '';
      return;
    }
    const stuck = parseFloat(getComputedStyle(sideSticky).top) || 0;
    const delta = Math.min(0, pinned.getBoundingClientRect().top - stuck);
    inner.style.transform = delta < -0.5 ? 'translateY(' + delta + 'px)' : '';
  }
  window.addEventListener('scroll', syncLogo, { passive: true });
  window.addEventListener('resize', syncLogo);
  if (window.lenis && window.lenis.on) {
    window.lenis.on('scroll', syncLogo);
  }
  syncLogo();

  if (shell) {
    /* Measure the fixed header instead of guessing. #nav is remora.com's
       chrome; a stock theme has a <header> and no #nav, so fall back to it
       or every offset keeps the stylesheet's calc. Ceil, not round: half a
       pixel down puts content back under the header's edge. The measurement
       is published on the shell only. */
    const siteNav = document.getElementById('nav') || document.querySelector('header');
    const syncNavHeight = function() {
      if (!siteNav) {
        return;
      }
      const bar = siteNav.querySelector('.nav__inner') || siteNav;
      const h = Math.ceil(bar.getBoundingClientRect().height);
      if (h > 0) {
        shell.style.setProperty('--kb-nav-h', h + 'px');
      }
    };
    syncNavHeight();
    window.addEventListener('resize', syncNavHeight);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncNavHeight).catch(function() {});
    }

    const sideScroller = shell.querySelector('.kb-side__sticky');
    const sideContent = shell.querySelector('.kb-side__scroll');
    let sideLenis = null;
    const fineDesktop = window.matchMedia('(min-width: 1021px) and (hover: hover) and (pointer: fine)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function collapsed() {
      return shell.classList.contains('is-collapsed');
    }

    function syncSideLenis() {
      const wanted = fineDesktop.matches && !reduceMotion.matches &&
        typeof Lenis !== 'undefined' && !!sideScroller && !!sideContent;
      if (wanted && !sideLenis) {
        sideLenis = new Lenis({
          wrapper: sideScroller,
          content: sideContent,
          duration: 0.8,
          easing: function(t) { return 1 - Math.pow(1 - t, 3); },
          smoothWheel: true,
          overscroll: false,
          autoRaf: true,
        });
      } else if (!wanted && sideLenis) {
        sideLenis.destroy();
        sideLenis = null;
      } else if (sideLenis) {
        sideLenis.resize();
      }
    }
    if (fineDesktop.addEventListener) {
      fineDesktop.addEventListener('change', syncSideLenis);
    }
    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', syncSideLenis);
    }

    const toggles = Array.prototype.slice.call(shell.querySelectorAll('[data-kb-toggle]'));
    const sideToggle = shell.querySelector('.kb-side__toggle');
    const browse = shell.querySelector('.kb-browse');
    const side = shell.querySelector('.kb-side');
    const backdrop = shell.querySelector('.kb-side__backdrop');
    const drawerBackground = [shell.querySelector('.kb-main'), siteNav, document.getElementById('contact')];
    if (backdrop) {
      shell.insertBefore(backdrop, side);
    }

    function apply(isCollapsed) {
      const drawerOpen = phone.matches && !isCollapsed;
      const focusInDrawer = side.contains(document.activeElement);
      shell.classList.toggle('is-collapsed', isCollapsed);
      drawerBackground.forEach(function(el) {
        if (el) {
          el.inert = drawerOpen;
        }
      });
      side.inert = phone.matches && isCollapsed;
      if (drawerOpen) {
        side.setAttribute('role', 'dialog');
        side.setAttribute('aria-modal', 'true');
      } else {
        side.removeAttribute('role');
        side.removeAttribute('aria-modal');
      }
      if (sideToggle) {
        sideToggle.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
        sideToggle.setAttribute('aria-label', 'Close categories');
      }
      if (browse) {
        browse.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
      }
      if (phone.matches) {
        document.documentElement.style.overflow = isCollapsed ? '' : 'hidden';
        if (window.lenis) {
          isCollapsed ? window.lenis.start() : window.lenis.stop();
        }
      } else {
        document.documentElement.style.overflow = '';
        if (window.lenis) {
          window.lenis.start();
        }
      }
      if (drawerOpen && sideToggle) {
        sideToggle.focus({ preventScroll: true });
      } else if (phone.matches && focusInDrawer && browse) {
        browse.focus({ preventScroll: true });
      }
      syncSideLenis();
    }

    toggles.forEach(function(el) {
      el.addEventListener('click', function() {
        apply(!collapsed());
      });
    });

    document.addEventListener('keydown', function(e) {
      if (collapsed() || !phone.matches) {
        return;
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        apply(true);
        if (browse) {
          browse.focus({ preventScroll: true });
        }
        return;
      }
      if (e.key !== 'Tab') {
        return;
      }
      const items = Array.prototype.filter.call(side.querySelectorAll('a[href], button, input'), function(el) {
        return el.offsetParent !== null;
      });
      const first = items[0];
      const last = items[items.length - 1];
      if (!first || !last) {
        return;
      }
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    const STORE_KEY = 'kb:reveal';
    const SCROLL_KEY = 'kb:side-scroll';
    let cameFromSidebar = false;
    let savedSideScroll = null;
    /* A stored category path can still end in the slash the 301 strips
       (a cached page, or any href that was not slashless). The arrival
       check compares the two without it. */
    function pathKey(pathname) {
      if (!pathname || pathname === '/') {
        return pathname || '';
      }
      return pathname.replace(/\/+$/, '');
    }
    try {
      cameFromSidebar = pathKey(sessionStorage.getItem(STORE_KEY)) === pathKey(location.pathname);
      if (cameFromSidebar) {
        sessionStorage.removeItem(STORE_KEY);
      }
      const rawScroll = sessionStorage.getItem(SCROLL_KEY);
      if (rawScroll != null && rawScroll !== '') {
        const n = parseFloat(rawScroll);
        if (!isNaN(n)) {
          savedSideScroll = n;
        }
        sessionStorage.removeItem(SCROLL_KEY);
      }
    } catch (e) {}

    shell.addEventListener('click', function(e) {
      const link = e.target.closest ? e.target.closest('a[href]') : null;
      if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey ||
          link.hasAttribute('download') || (link.target && link.target !== '_self')) {
        return;
      }
      const category = link.closest('[data-kb-category]');
      /* Same-page links do not navigate. On a phone, a same-page link that
         is not a category row closes the drawer. */
      const destination = new URL(link.href, location.href);
      if (!link.hash && destination.pathname === location.pathname && destination.search === location.search) {
        e.preventDefault();
        if (phone.matches && !category) {
          apply(true);
        }
        return;
      }
      if (category) {
        try {
          sessionStorage.setItem(STORE_KEY, new URL(link.href, location.href).pathname);
        } catch (err) {}
      }
      if (sideScroller && link.closest('.kb-side')) {
        const y = sideLenis ? sideLenis.scroll : sideScroller.scrollTop;
        try {
          sessionStorage.setItem(SCROLL_KEY, String(y));
        } catch (err) {}
      }
      /* A category click must not close the phone drawer: the next page
         reopens it from the stored arrival. Other sidebar links do close it. */
      if (phone.matches && !category && link.closest('.kb-side')) {
        apply(true);
      }
    });

    let userMoved = false;
    ['wheel', 'touchstart', 'keydown'].forEach(function(type) {
      window.addEventListener(type, function() {
        userMoved = true;
      }, { once: true, passive: true });
    });

    function revealActiveInSidebar() {
      if (!sideScroller || phone.matches) {
        return;
      }
      const group = shell.querySelector('.kb-tree__group.is-open');
      const sub = shell.querySelector('.kb-tree__sublink.is-active');
      const target = group || shell.querySelector('.kb-tree__link.is-active');
      if (!target) {
        return;
      }
      const headEl = shell.querySelector('.kb-side__pinned') || shell.querySelector('.kb-side__head');
      const headH = headEl ? headEl.getBoundingClientRect().height : 0;
      const view = sideScroller.getBoundingClientRect();
      function shift(el, pad) {
        const r = el.getBoundingClientRect();
        const above = r.top - (view.top + headH + pad);
        const below = r.bottom - (view.bottom - pad);
        if (above < 0) {
          return above;
        }
        if (below > 0) {
          return below;
        }
        return 0;
      }
      const delta = shift(target, 8);
      const max = sideScroller.scrollHeight - sideScroller.clientHeight;
      let next = Math.max(0, Math.min(max, sideScroller.scrollTop + delta));
      if (sub) {
        const after = sub.getBoundingClientRect().bottom - delta;
        if (after > view.bottom - 8) {
          next = Math.max(0, Math.min(max, sideScroller.scrollTop + shift(sub, 8)));
        }
      }
      if (Math.round(next) === Math.round(sideScroller.scrollTop)) {
        return;
      }
      if (sideLenis) {
        sideLenis.scrollTo(next, { immediate: true });
      } else {
        sideScroller.scrollTop = next;
      }
    }

    function revealCategoryContent() {
      let head = shell.querySelector('.kb-page-head');
      const browseButton = shell.querySelector('.kb-browse');
      if (browseButton && browseButton.offsetParent !== null) {
        head = browseButton;
      }
      if (!head) {
        return;
      }
      const navH = parseFloat(getComputedStyle(shell).getPropertyValue('--kb-nav-h')) || 0;
      const y = (window.scrollY || 0) + head.getBoundingClientRect().top - navH - 24;
      if (y <= 1) {
        return;
      }
      if (window.lenis) {
        window.lenis.scrollTo(y, { immediate: true });
      } else {
        window.scrollTo(0, y);
      }
    }

    function restoreSideScroll() {
      if (savedSideScroll == null || !sideScroller || collapsed()) {
        return false;
      }
      const max = sideScroller.scrollHeight - sideScroller.clientHeight;
      const next = Math.max(0, Math.min(max, savedSideScroll));
      if (sideLenis) {
        sideLenis.scrollTo(next, { immediate: true });
      } else {
        sideScroller.scrollTop = next;
      }
      return true;
    }

    function placeOnArrival() {
      if (userMoved) {
        return;
      }
      if (!restoreSideScroll()) {
        revealActiveInSidebar();
      }
      if (cameFromSidebar) {
        revealCategoryContent();
      }
    }

    /* Crossing down closes the drawer. Crossing up always expands: there
       is no desktop collapse control, so no collapsed preference to restore. */
    function onBreakpoint() {
      apply(phone.matches);
    }
    if (phone.addEventListener) {
      phone.addEventListener('change', onBreakpoint);
    } else if (phone.addListener) {
      phone.addListener(onBreakpoint);
    }
    /* No page ships is-collapsed. Desktop starts expanded. The phone drawer
       starts closed unless the visitor arrived from a sidebar category click. */
    apply(phone.matches ? !cameFromSidebar : false);

    placeOnArrival();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(placeOnArrival).catch(function() {});
    }
    window.addEventListener('load', placeOnArrival);

    function kbHeroWash() {
      const canvas = document.getElementById('kbHeroCanvas');
      if (!canvas) {
        return;
      }
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const gl = canvas.getContext('webgl', { antialias: false, alpha: false });
      if (!gl) {
        return;
      }
      const FRAG = [
        'precision highp float;',
        'uniform vec2 u_res; uniform float u_time; uniform vec4 u_ripples[64];',
        'float hash(vec2 p){ return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453123); }',
        'float noise(vec2 p){ vec2 i = floor(p), f = fract(p); vec2 u = f * f * (3.0 - 2.0 * f);',
        '  return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), u.x), mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), u.x), u.y); }',
        'float fbm(vec2 p){ float v = 0.0, a = 0.5; for (int i = 0; i < 5; i++){ v += a * noise(p); p *= 2.02; a *= 0.5; } return v; }',
        'void main(){',
        '  vec2 uv = gl_FragCoord.xy / u_res; float aspect = u_res.x / u_res.y;',
        '  vec2 p = uv * vec2(aspect, 1.0) * 2.2; vec2 slope = vec2(0.0);',
        '  for (int i = 0; i < 64; i++){',
        '    vec4 rp = u_ripples[i]; float age = u_time - rp.z;',
        '    if (rp.w <= 0.0 || age < 0.0 || age > 5.0) continue;',
        '    vec2 rc = rp.xy * vec2(aspect, 1.0) * 2.2; vec2 dd = p - rc;',
        '    float dist = sqrt(dot(dd, dd) + 0.01);',
        '    float fade = smoothstep(0.0, 0.12, age) * exp(-age * 1.05) * (1.0 - smoothstep(4.0, 5.0, age)) * rp.w;',
        '    float phase = (dist - age * 0.55) / 0.20;',
        '    slope += (dd / dist) * (-2.0 * phase * exp(-phase * phase)) * fade;',
        '  }',
        '  slope /= sqrt(1.0 + dot(slope, slope));',
        '  vec2 rippleDisp = slope * 0.045;',
        '  float crest = dot(slope, vec2(-0.6, 0.8)) * 0.18;',
        '  p += rippleDisp; float t = u_time * 0.05; vec2 pw = p * vec2(0.6, 1.8);',
        '  vec2 q = vec2(fbm(pw + vec2(t * 1.3, t * 0.2)), fbm(pw + vec2(5.2, 1.3) - vec2(t * 0.9, t * 0.3)));',
        '  vec2 r = vec2(fbm(pw + 3.5 * q + vec2(1.7, 9.2) + vec2(t * 1.7, 0.0)), fbm(pw + 3.5 * q + vec2(8.3, 2.8) - vec2(t * 1.2, 0.0)));',
        '  float f = fbm(pw + 3.5 * r + vec2(t * 0.6, 0.0));',
        '  vec3 dark = vec3(0.094, 0.059, 0.078); vec3 mid = vec3(0.145, 0.227, 0.294);',
        '  vec3 blue = vec3(0.478, 0.592, 0.749); vec3 acc = vec3(0.604, 0.698, 0.824);',
        '  float depth = smoothstep(-0.1, 1.1, uv.y);',
        '  vec3 col = mix(dark, mid, smoothstep(0.1, 0.85, f) * (0.65 + 0.5 * depth));',
        '  col = mix(col, blue, smoothstep(0.42, 0.95, f * length(q)) * (0.5 + 0.45 * depth));',
        '  float crestLine = smoothstep(0.55, 0.9, f * length(r));',
        '  col = mix(col, acc, crestLine * 0.24); col += acc * pow(crestLine, 4.0) * 0.18;',
        '  col += (blue * 0.55 + acc * 0.30) * crest;',
        '  col *= 1.0 - 0.45 * dot(uv - 0.5, uv - 0.5) * 2.0;',
        '  gl_FragColor = vec4(col, 1.0);',
        '}',
      ].join('\n');
      function compile(type, src) {
        const s = gl.createShader(type);
        gl.shaderSource(s, src);
        gl.compileShader(s);
        return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null;
      }
      const vs = compile(gl.VERTEX_SHADER, 'attribute vec2 a_pos; void main(){ gl_Position = vec4(a_pos, 0.0, 1.0); }');
      const fs = compile(gl.FRAGMENT_SHADER, FRAG);
      if (!vs || !fs) {
        return;
      }
      const prog = gl.createProgram();
      gl.attachShader(prog, vs);
      gl.attachShader(prog, fs);
      gl.linkProgram(prog);
      gl.useProgram(prog);
      const buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      const loc = gl.getAttribLocation(prog, 'a_pos');
      gl.enableVertexAttribArray(loc);
      gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      const uRes = gl.getUniformLocation(prog, 'u_res');
      const uTime = gl.getUniformLocation(prog, 'u_time');
      const uRipples = gl.getUniformLocation(prog, 'u_ripples');
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      const wash = canvas.parentNode;
      const content = mainInner();
      /* Declared before resize(): reduced motion paints on that first call,
         and a const read there is a temporal dead zone, not a hoisted var. */
      const start = performance.now();
      const ripples = new Float32Array(256);
      let idx = 0;
      /* The wash ends halfway down the first card, or down the CTA when a
         search has no results. */
      function resize() {
        const card = content ? Array.prototype.find.call(content.querySelectorAll('.kb-card, .kb-cta'), function(el) {
          return el.offsetParent !== null;
        }) : null;
        const rect = card ? card.getBoundingClientRect() : null;
        wash.style.height = rect ? rect.top + rect.height / 2 - wash.getBoundingClientRect().top + 'px' : '';
        const width = Math.floor(canvas.offsetWidth * dpr);
        const height = Math.floor(canvas.offsetHeight * dpr);
        if (canvas.width === width && canvas.height === height) {
          return;
        }
        canvas.width = width;
        canvas.height = height;
        gl.viewport(0, 0, canvas.width, canvas.height);
        if (reduce) {
          frame();
        }
      }
      window.addEventListener('resize', resize);
      if (content && typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(resize).observe(content);
      }
      resize();
      let lastX = null;
      let lastY = null;
      let travelled = 0;
      function now() {
        return (performance.now() - start) / 1000;
      }
      function spawn(x, y, amp) {
        const rect = canvas.getBoundingClientRect();
        if (y < rect.top || y > rect.bottom || x < rect.left || x > rect.right) {
          return;
        }
        const o = idx * 4;
        ripples[o] = (x - rect.left) / rect.width;
        ripples[o + 1] = 1 - (y - rect.top) / rect.height;
        ripples[o + 2] = now();
        ripples[o + 3] = amp;
        idx = (idx + 1) % 64;
      }
      window.addEventListener('mousemove', function(e) {
        if (lastX === null) {
          lastX = e.clientX;
          lastY = e.clientY;
          return;
        }
        const dx = e.clientX - lastX;
        const dy = e.clientY - lastY;
        const dist = Math.hypot(dx, dy);
        if (dist < 0.5) {
          return;
        }
        let cursor = 30 - travelled;
        while (cursor <= dist) {
          const t = cursor / dist;
          spawn(lastX + dx * t, lastY + dy * t, 0.7);
          cursor += 30;
        }
        travelled = dist - (cursor - 30);
        lastX = e.clientX;
        lastY = e.clientY;
      }, { passive: true });
      window.addEventListener('click', function(e) {
        spawn(e.clientX, e.clientY, 1);
      });
      function frame() {
        gl.uniform2f(uRes, canvas.width, canvas.height);
        gl.uniform1f(uTime, now());
        gl.uniform4fv(uRipples, ripples);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
        if (!reduce) {
          requestAnimationFrame(frame);
        }
      }
      frame();

      let still = null;
      window.addEventListener('pageswap', function(e) {
        if (!e.viewTransition) {
          return;
        }
        gl.drawArrays(gl.TRIANGLES, 0, 3);
        still = canvas.cloneNode(false);
        still.getContext('2d').drawImage(canvas, 0, 0);
        canvas.replaceWith(still);
      });
      window.addEventListener('pageshow', function() {
        if (!still) {
          return;
        }
        still.replaceWith(canvas);
        still = null;
      });
    }
    if (home) {
      kbHeroWash();
    }

    /* Resolve the initial drawer position before enabling its transitions.
       Without this class the phone drawer stays visibility:hidden, which is
       what keeps a no-JS visitor from being covered by it. */
    void shell.offsetWidth;
    shell.classList.add('is-ready');
    if (sideToggle && side.getAttribute('aria-modal') === 'true') {
      sideToggle.focus({ preventScroll: true });
    }
  }

  /* Both search forms GET the landing page, which renders the results, and
     the search runs as the visitor types. On the landing, the results region
     is fetched from that same URL and swapped in place, and the address bar
     follows the term. On a category or article page, a pause in typing
     navigates to the landing, which puts the caret back in the search field
     and picks up anything typed while the page changed. An empty submit is
     refused here and, without this script, lands on the ordinary landing
     page. The mobile clear button empties the field. */
  function bindSearchForms() {
    const forms = Array.prototype.filter.call(document.querySelectorAll('.kb-side__search, .kb-mobile-search'), function(form) {
      return !!form.querySelector('input');
    });
    const FOCUS_KEY = 'kb:search-focus';
    const TYPING_PAUSE_MS = 300;
    /* Leaving the page drops whatever is typed between the landing appearing
       and this script focusing its field, so off the landing the pause that
       counts as done typing is longer. */
    const LEAVING_PAUSE_MS = 1000;
    const regions = new Map();
    const clear = document.querySelector('.kb-mobile-search .kb-mobile-clear');
    let shownTerm = (new URL(location.href).searchParams.get('q') || '').trim();
    let typingTimer = null;
    let pending = null;
    /* The term a navigation to the landing is carrying, while it loads. */
    let leavingFor = null;

    /* The landing honors this only when it shows results for `q`, so a
       navigation that never arrived cannot rewrite a later search. */
    function rememberTyping(typed) {
      try {
        sessionStorage.setItem(FOCUS_KEY, JSON.stringify({ q: leavingFor, typed: typed }));
      } catch (e) {}
    }

    /* The server ignores one-character words, so a term without a longer
       one would only replace the page with "no answers". */
    function searchable(term) {
      return /[\p{L}\p{N}]{2}/u.test(term);
    }

    function searchUrl(form, term) {
      const url = new URL(form.getAttribute('action') || form.action, location.href);
      url.search = '';
      if (term) {
        url.searchParams.set('q', term);
      }
      return url.href;
    }

    /* Regions are cached per URL, so backspacing to an earlier term is
       instant. A newer term aborts the request for an older one. A failed
       request leaves the results that are showing, and Enter still submits. */
    async function showResults(form, term) {
      if (pending) {
        pending.abort();
        pending = null;
      }
      if (term === shownTerm) {
        return;
      }
      const url = searchUrl(form, term);
      let html = regions.get(url);
      if (html === undefined) {
        pending = new AbortController();
        try {
          const response = await fetch(url, { signal: pending.signal });
          if (!response.ok) {
            return;
          }
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const region = page.querySelector('[data-kb-results]');
          if (!region) {
            return;
          }
          html = region.innerHTML;
          regions.set(url, html);
        } catch (e) {
          return;
        }
      }
      const current = document.querySelector('[data-kb-results]');
      if (!current) {
        return;
      }
      current.innerHTML = html;
      shownTerm = term;
      history.replaceState(history.state, '', url);
      /* A live region inserted already filled is not read out, so the count
         is announced through one that stays in the page. */
      const announcer = document.querySelector('[data-kb-announce]');
      const count = current.querySelector('.kb-results__count');
      if (announcer) {
        announcer.textContent = count ? count.textContent : '';
      }
    }

    function onType(form, input) {
      const term = input.value.trim();
      forms.forEach(function(other) {
        const otherInput = other.querySelector('input');
        if (otherInput !== input) {
          otherInput.value = input.value;
        }
      });
      if (clear) {
        clear.hidden = input.value === '';
      }
      clearTimeout(typingTimer);
      typingTimer = setTimeout(function() {
        if (home && (term === '' || searchable(term))) {
          showResults(form, term);
        } else if (!home && searchable(term)) {
          leavingFor = term;
          rememberTyping(input.value);
          location.assign(searchUrl(form, term));
        }
      }, home ? TYPING_PAUSE_MS : LEAVING_PAUSE_MS);
    }

    forms.forEach(function(form) {
      const input = form.querySelector('input');
      input.addEventListener('input', function() {
        if (leavingFor !== null) {
          rememberTyping(input.value);
        }
        onType(form, input);
      });
      /* Enter on results already showing does nothing; any other term takes
         the ordinary GET. */
      form.addEventListener('submit', function(e) {
        const term = input.value.trim();
        if (!term || (home && term === shownTerm)) {
          e.preventDefault();
          if (!term) {
            input.focus();
          }
          return;
        }
        clearTimeout(typingTimer);
      });
    });

    /* Arriving from a search typed on a category or article page. */
    if (home && shownTerm) {
      let typed = null;
      try {
        const stored = JSON.parse(sessionStorage.getItem(FOCUS_KEY));
        sessionStorage.removeItem(FOCUS_KEY);
        if (stored && stored.q === shownTerm) {
          typed = stored.typed;
        }
      } catch (e) {}
      const field = typeof typed === 'string' && document.querySelector(phone.matches ? '.kb-mobile-search input' : '.kb-side__search input');
      if (field) {
        if (field.value !== typed) {
          field.value = typed;
          onType(field.form, field);
        }
        field.focus({ preventScroll: true });
        field.setSelectionRange(field.value.length, field.value.length);
      }
    }

    const mobile = clear && clear.closest('.kb-mobile-search');
    const input = mobile && mobile.querySelector('input');
    if (!input) {
      return;
    }
    clear.addEventListener('click', function() {
      input.value = '';
      input.focus();
      onType(mobile, input);
    });
  }
  bindSearchForms();
})();
